// extracted by mini-css-extract-plugin
module.exports = {"mainInputBox":"input_mainInputBox__1XBCz"};